import React from "react";

const JobHeader = ({ job, title, appLanguage, showApply = true }) => {
  return (
    <header className="mb-3">
      <h1 className="fw-bold" style={{ color: "#008080" }}>{title}</h1>
      <p className="text-muted mb-3" style={{ textTransform: "capitalize" }}>
        {job.Governorate__c ? `${job.Governorate__c.toLowerCase()}, Iraq` : "Iraq"}
      </p>
      {showApply && (
        <a href="#apply" className="btn btn-success btn-sm px-3">
          Apply for this job
        </a>
      )}
    </header>
  );
};

export default JobHeader;
